import { useEffect, useState } from 'react'

import { API_URL } from '../../../../config/config'

import { checkFileSize } from './checkFileSize'

const getPercentLoaded = event => Math.round((event.loaded * 100) / event.total)

export const useAttachmentFile = file => {
  const [status, setStatus] = useState('loading') //loading, success, error
  const [loadedFile, setLoadedFile] = useState({
    name: file.name,
    type: file.type.split('/')[0],
  })
  const [percentUpload, setPercentUpload] = useState(0)
  const [xhr] = useState(new XMLHttpRequest()) // eslint-disable-line

  useEffect(() => {
    if (status !== 'success') {
      setLoadedFile({
        ...loadedFile,
        status,
      })
    }
    if (status === 'success' && xhr.response) {
      setLoadedFile({
        ...loadedFile,
        status,
        url: xhr.response.url,
      })
    }
  }, [status])

  const getFileLink = () => {
    if (!checkFileSize(file)) {
      setStatus('error')
      return
    }

    xhr.responseType = 'json'
    xhr.open('POST', `${API_URL}/custom/file`, true)

    xhr.upload.onprogress = event => setPercentUpload(getPercentLoaded(event))
    xhr.onerror = () => setStatus('error')

    xhr.onload = () => {
      if (xhr.status === 200) {
        setStatus('success')
      }
      if (xhr.status !== 200) {
        setStatus('error')
      }
    }

    const formData = new FormData() // eslint-disable-line
    formData.append('file', file)

    xhr.send(formData)
  }

  const onStopUpload = () => status === 'loading' && xhr.abort()

  return {
    status,
    loadedFile,
    percentUpload,
    onStopUpload,
    getFileLink,
  }
}
